import { render, staticRenderFns } from "./btn-primary3.vue?vue&type=template&id=c0056b5e&scoped=true&"
import script from "./btn-primary3.vue?vue&type=script&lang=js&"
export * from "./btn-primary3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0056b5e",
  null
  
)

export default component.exports